import { StyleSheet } from 'react-native';
import { COLORS, FONTS } from '../../constants';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    marginTop: 20,
    paddingHorizontal: 5,
  },
  markedPeriod: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    height: 50,
  },
  arrowButton: {
    padding: 5,
  },
  arrowStyle: {
    height: 13,
    width: 10,
    resizeMode: 'contain',
    tintColor: COLORS.GREEN,
  },
  monthButton: {
    fontSize: 20,
    fontWeight: 'bold',
    marginHorizontal: 10,
  },
  monthText: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  calendarContainer: {
    flexDirection: 'column',
  },
  calendarRow: {
    flexDirection: 'row',
    gap: 3,
    marginBottom: 3,
  },
  dayButton: {
    flex: 1,
    height: 40,
    padding: 4,
    borderRadius: 1,
    backgroundColor: COLORS.LIGHT_GREY,
  },
  dayText: {
    fontSize: 13,
    fontFamily: FONTS.AvenirMedium,
    textTransform: 'uppercase',
    color: COLORS.DARKER_GREY,
  },
  dayOfWeekText: {
    fontSize: 12,
  },
  emptyDay: {
    width: 40,
    height: 100,
    margin: 5,
  },
  dayTitle: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 13,
    textTransform: 'uppercase',
    textAlign: 'center',
    color: COLORS.GREEN,
  },
  selectWrapper: {
    paddingHorizontal: 20,
    flexDirection: 'row',
    zIndex: 100,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
  },
  currentDate: {
    color: COLORS.GREEN,
    fontWeight: '500',
    fontFamily: FONTS.IowanOldStyleBTRoman,
    fontSize: 16,
    lineHeight: 28,
    letterSpacing: 2,
    textTransform: 'uppercase',
    paddingHorizontal: 8,
  },
});
